import FinancialStats from './_FinancialStats';

export default FinancialStats;
